import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Submit14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.2501 2V7.25H4.31077L7.03044 4.53033L5.96978 3.46967L1.43945 8L5.96978 12.5303L7.03044 11.4697L4.31078 8.75H12.7501V2H11.2501Z'
      fill='currentColor'
    />
  </Svg>
);

Submit14.displayName = 'Submit14';
export default Submit14;
